import React, { useRef, useState } from "react";
import {
    Container,
    Row,
    Col,
    Button,
    Input,
    Label,
    FormGroup,
} from "reactstrap";
import { FiEdit, FiUpload, FiXCircle } from "react-icons/fi";
import ReactQuill from "react-quill";
import styles from "./PostComposer.module.scss";
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";
import UploadMedia from "../../../../common/UploadMedia/UploadMedia";
import FormInput from "../../../../common/AdminCommonComponents/FormInput/FormInput";

const PostComposer = () => {
    const mediaImagesInputRef = useRef(null);
    const [selectedPlatforms, setSelectedPlatforms] = useState([]);
    const [postContent, setPostContent] = useState("");
    const [mediaImages, setMediaImages] = useState([]);

    const platforms = ["Facebook", "Twitter", "Instagram", "LinkedIn"];

    const togglePlatform = (platform) => {
        setSelectedPlatforms((prev) =>
            prev.includes(platform)
                ? prev.filter((p) => p !== platform)
                : [...prev, platform]
        );
    };

    const [formData, setFormData] = useState({
        startDate: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };



    return (
        <Container fluid className={styles.postComposer}>
            {/* Title */}
            <h4 className={styles.title}>
                <FiEdit color="#008CD6" /> Post Composer
            </h4>

            <Row className={styles.composerRow}>
                {/* Platform Selection */}
                <Col xl="3" className={styles.sidebarColumn}>
                    <div className={styles.sidebar}>
                        <h5 className={styles.sectionHeading}>Platform Selection</h5>
                        {platforms.map((platform) => (
                            <FormGroup check key={platform}>
                                <Input
                                    type="checkbox"
                                    checked={selectedPlatforms.includes(platform)}
                                    onChange={() => togglePlatform(platform)}
                                />
                                <Label check>{platform}</Label>
                            </FormGroup>
                        ))}
                    </div>
                </Col>

                {/* Content Editor */}
                <Col xl="6" className={styles.editorColumn}>
                    <h5 className={styles.sectionHeading}>Content Editor</h5>

                    <ReactQuill
                        theme="snow"
                        value={postContent}
                        onChange={setPostContent}
                        placeholder="Write your post..."
                        className={styles.textEditor}
                    />

                    {/* Media Upload */}
                    <div className={styles.btnContainer}>
                        <DynamicButton
                            theme="purple"
                            onClick={() =>
                                mediaImagesInputRef.current &&
                                mediaImagesInputRef.current.click()
                            }
                        >
                            Add Media
                        </DynamicButton>

                        <div className={styles.uploadedMediaContainer}>
                            <UploadMedia
                                pictures={mediaImages}
                                setPictures={setMediaImages}
                                maxMedia={6}
                                allowImages={true}
                                allowVideos={true}
                                fileInputRef={mediaImagesInputRef}
                                hideUploadLabel={true}
                            />
                        </div>
                    </div>


                    {/* Time Schedule */}
                    <h5 className={styles.sectionHeading}>Time Schedule</h5>
                    <h6 className={styles.periodHeading}>Live Period</h6>
                    <Row className="g-0">
                        <Col sm={6} className="pe-sm-3">
                            <FormInput
                                type="date"
                                placeholder="Start date"
                                id="startDate"
                                name="startDate"
                                value={formData.startDate}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col sm={6} className="ps-sm-3">
                            <FormInput
                                type="date"
                                placeholder="End date"
                                id="endDate"
                                name="endDate"
                                value={formData.endDate}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col sm={6} className="pe-sm-3">
                            <FormInput
                                type="time"
                                placeholder="Time"
                                id="time"
                                name="time"
                                value={formData.time}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col sm={6} className="ps-sm-3">
                            <FormInput
                                type="time"
                                placeholder="Time"
                                id="secondTime"
                                name="secondTime"
                                value={formData.secondTime}
                                onChange={handleChange}
                            />
                        </Col>
                    </Row>
                </Col>

                {/* Post Preview */}
                <Col xl="3" className={styles.previewColumn}>
                    <div className={styles.previewSection}>
                        <h5 className={styles.previewHeading}>Post Preview</h5>
                        <Row className={styles.platformTabs}>
                            {platforms.map((platform) => (
                                <Col lg={6} xl={12} xxl={6} className={styles.platformTabColumn}>
                                    <Button key={platform} outline color="secondary" className={styles.platformBtn}>
                                        {platform}
                                    </Button>
                                </Col>
                            ))}
                        </Row>
                        <div className={styles.previewBox}></div>
                    </div>
                </Col>
            </Row>

            {/* Footer Actions */}
            <div className={styles.footerActions}>
                <Button outline color="secondary" className={styles.cancelBtn}>Cancel</Button>
                <DynamicButton theme="purple">Schedule Post</DynamicButton>
            </div>
        </Container>
    );
};

export default PostComposer;